import { PriceDisplayWithTerm } from 'pricing-pages-ui-components/price/PriceDisplayWithTerm';
import SuiteProductLevelIdentifiersMap from 'pricing-pages-ui/constants/merchCards/SuiteProductLevelIdentifiersMap';
import { useCurrencyCodeUnitToDisplay, useDisplayedCurrencyCode } from '../../../hooks/useCurrencies';
import { useCrmSuitePricingInfo } from './useCrmSuitePricingInfo';
import { jsx as _jsx } from "react/jsx-runtime";
export const CrmSuitePriceFeatureTable = ({
  productLevel
}) => {
  const currencyCode = useDisplayedCurrencyCode();
  const currencyCodeUnit = useCurrencyCodeUnitToDisplay();
  const pricingInfo = useCrmSuitePricingInfo({
    productLevel
  });
  return pricingInfo && /*#__PURE__*/_jsx(PriceDisplayWithTerm, {
    pricingInfo: pricingInfo,
    seleniumId: SuiteProductLevelIdentifiersMap[productLevel],
    currencyCode: currencyCode,
    currencyCodeUnit: currencyCodeUnit
  });
};
export default CrmSuitePriceFeatureTable;